var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"language":_vm.language},on:{"language-change":_vm.handleLanguageChange}}),_c('div',{class:_vm.isProjectPage ? 'project-page-shell' : ''},[_c(_vm.currentView,{tag:"component"})],1),_c('Footer',{attrs:{"language":_vm.language}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }